module.exports = __webpack_public_path__ + "static/naujiena-miskai-apdovanojimai-9b0b6cffb28a1a3fe198f888f3abc004.jpg";